import {AutogenLayoutTriumphPayStatuses} from "./autogen/AutogenLayoutTriumphPayStatuses";
import {DataSourceExecutionEvent, TableRowDisplayEvent} from "@mcleod/components";

export class TriumphPayStatuses extends AutogenLayoutTriumphPayStatuses {


    sourceInterfaceCodesBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter = {code_type: 'TV'};
    }
}
